import styles from "./style.module.scss";
import VLSearchFilter from "views/uikit/VLSearchFilter";
import RadioGroup from "views/components/LabelPropagation/ReviewModal/RadioGroup";
import { Option } from "views/uikit/FormFields/SelectList";
import { useEffect, useState } from "react";

interface ReviewModalClassesListProps {
  labelsOptions: Option[];
  selected?: any;
  onCheckBoxClick?: (item: { labelId: string; sampleId: string }) => void;
  className?: string;
}
export default function ReviewModalClassesList({
  labelsOptions,
  selected,
  onCheckBoxClick,
  className,
}: ReviewModalClassesListProps) {
  const [filteredLabels, setFilteredLabels] = useState(labelsOptions);
  const [radioValue, setRadioValue] = useState(selected?.labelId);
  useEffect(() => {
    setRadioValue(selected?.labelId);
  }, [selected]);

  useEffect(() => {
    setFilteredLabels(labelsOptions);
  }, [labelsOptions]);

  return (
    <div className={className}>
      <div className={styles.title}>Assign Label</div>
      <div className={styles.filter}>
        <VLSearchFilter
          items={labelsOptions}
          filterKey="label"
          placeholder="Search labels..."
          onFilter={setFilteredLabels}
        />
      </div>

      <div className={styles.listWrapper}>
        <RadioGroup
          defaultValue={radioValue}
          onChange={async (value) => {
            setRadioValue(value);
            await onCheckBoxClick?.({
              labelId: value,
              sampleId: selected.id,
            });
          }}
          options={filteredLabels.map((option) => ({
            label: option.label,
            value: option.value,
          }))}
        />
      </div>
    </div>
  );
}
